<template>
	<router-link v-if="Object.keys(event).length > 0" class="elevation-3 event-list-item-a" :to="{ name: 'event', params: { slug: event.slug }}">
		<v-card flat tile class="p-relative event-list-item-card">
			<v-img
				class="event-list-item-img"
				:style="{'background-color': defaultBackgroundColor, 'box-shadow': 'inset 0px 0px 0px 1px gray'}"
				:src="event.primary_image.image"
				:lazy-src="event.primary_image.image + '?w=10)'"
				:srcset="`${event.primary_image.image}?w=150 150w,
							${event.primary_image.image}?w=320 320w,
							${event.primary_image.image}?w=640 640w`"
				gradient="to bottom,
									rgba(0, 0, 0, 0.2) 0%,
									rgba(0, 0, 0, 0) 15%,
									rgba(0, 0, 0, 0) 60%,
									rgba(0, 0, 0, 0.25) 75%,
									rgba(0, 0, 0, 0.75) 100%"
				aspect-ratio="1.77"
			>
				<v-layout
					slot="placeholder"
					fill-height
					align-center
					justify-center
					ma-0
				>
					<v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
				</v-layout>
				<v-layout>
					<v-flex xs12>
						<div class="event-list-card__price text-xs-center">
							<div v-if="event.cancelled && isAttending" class="error--text">
								Cancelled
							</div>
							<div v-else-if="event.host.user.pk === user.pk" style="z-index: 200;">
								<v-tooltip bottom>
									<v-icon class="success--text" slot="activator">fal fa-handshake</v-icon>
									<span>You're hosting</span>
								</v-tooltip>
							</div>
							<div v-else-if="isAttending">
								<v-tooltip bottom>
									<v-icon class="success--text" slot="activator">fal fa-calendar-check</v-icon>
									<span>You're attending</span>
								</v-tooltip>
							</div>
							<div v-else-if="event.cancelled && !isAttending" class="white--text" style="font-size: 1em; line-height: 1em;">
								sold<br>out
							</div>
							<div v-else-if="event.attendees.length < event.max_attendees">
								<span v-if="event.price > 0.0 && !freePass"><span style="font-size: 0.7em">$</span>{{ event.price }}</span><span v-else>FREE</span>
							</div>
							<div v-else class="white--text" style="font-size: 1em; line-height: 1em;">
								sold<br>out
							</div>
						</div>
						<div class="event-list-card__buttons ma-0 pr-1">
							<button
								type="button"
								class="event-list-card__button-icon"
								@click.stop.prevent="favoriteEvent(event)"
							>
								<v-icon>{{ likedEvent }}</v-icon>
							</button>
							<button
								type="button"
								class="event-list-card__button-icon event-list-card__button-margin"
								v-if="event.approved"
								@click.stop.prevent="shareModalOpen=true"
							>
								<v-icon>fal fa-share-alt</v-icon>
							</button>
						</div>
						<div class="event-list-card__text text-xs-left pl-1">
							<div style="display: flex; flex-direction: row; justify-content: space-between;">
								<div>
									<p class="event-list-card__category ma-0" style="margin-left: -5px!important;">
										{{ event.category }}
									</p>
									<p class="event-list-card__location-name ma-0">
										<span style="font-size: .75em;">@</span>
										<i>{{ event.location.name }}</i>
									</p>
									<div class="details-table ml-0">
										<div class="details-flex ml-0" style="margin-left: -10px;">
											<div class="details-icon ml-0" style="width: 30px; padding-left: 2px;!important">
												<i style="color: #BABABA;" class="fal fa-map-marker"></i>
											</div>
											<div style="margin-left: -13px;">
												<p class="event-list-card__location-address ma-0">{{locationShort(event.location)}}</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

					</v-flex>
				</v-layout>
			</v-img>
			<div style="position: absolute; right: -10px; bottom: 0; margin-bottom: 15px;">

				<div style="display: flex; flex-direction: column; justify-content: flex-end">
					<div class="event-list-card__date-circle text-xs-center">
						<v-avatar :size="mapSizeOuter" class="white event-page-circle-outer">
							<v-avatar :size="mapSizeInner" class="date-icon event-page-circle-inner">
								<div class="event-list-card__date-circle-text" style="color: #444;">
									<p style="font-size: 0.8em; font-weight: 300;" class="mb-0">{{weekday}}</p><p class="mb-0">{{ eventDate }}</p><p style="font-size: 0.8em;" class="mb-0">{{ formattedTime }}</p>
								</div>
							</v-avatar>
						</v-avatar>
					</div>
				</div>
			</div>
		</v-card>
		<div :to="{ name: 'event', params: { slug: event.slug } }" class="pa-1 mb-4 pl-3" style="display:block; width: 70%">
			<div class="event-card-heading-3 text-xs-left" style="color: #666!important" v-if="event.approved">{{ event.subtitle }}</div>
			<div class="event-card-heading-3 text-xs-left red--text" v-else>Not Live!  Awaiting approval</div>
		</div>
	</router-link>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { parse, format } from 'date-fns'
import { getDistance } from '~/utils/helper'
export default {
	props: ['event'],
	data() {
		return {
			IMAGE_URL: process.env.VUE_APP_IMAGE_URL,
			stuff: 'asdf',
			defaultBackgroundColor: '#25e585'
		}
	},
	created() {
		var colors = ['#25e585', '#78cbef', '#de6656', '#fd9827', '#f4e933'];
		this.defaultBackgroundColor = colors[Math.floor(Math.random() * colors.length)];
	},
	methods: {
		...mapActions(['favoriteEvent', 'setModalOpen', 'setShareModalEvent']),
		goToEvent() {
			this.$router.push({ name: 'event', params: { slug: this.event.slug } })
		},
		timeToAMPM(timeString) {
			let time = timeString
				.toString()
				.match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [timeString]

			if (time.length > 1) {
				time = time.slice(1)
				if (time.length > 3) {
					time.pop()
				}
				time[3] = time[0] < 12 ? 'a' : 'p'
				time[0] = +time[0] % 12 || 12
			}
			return time.join('')
		}
	},
	computed: {
		...mapGetters([
			'getVisitorLocation',
			'user',
			'getModalProp'
		]),
		shareModalOpen: {
			get() {
				return this.getModalProp('shareModal')
			},
			set(val) {
				this.setShareModalEvent(this.event)
				this.setModalOpen({ prop: 'shareModal', value: val })
			}
		},
		isAttending() {
			if (this.isHost) {
				return true
			}
			let attending = this.event.attendees.indexOf(this.user.uuid) > -1
			if (!attending) {
				attending = this.event.attendees.find(obj => {
					return obj.uuid === this.user.uuid
				})
				if (attending === undefined) {
					attending = false
				}
			}
			return attending
		},
		likedEvent() {
			if (this.user.liked_events.indexOf(this.event.pk) > -1) {
				return 'fas fa-heart'
			}
			return 'fal fa-heart'
		},
		eventMessage() {
			if (this.event.max_attendees - this.event.attendees.length <= 0) {
				return { message: 'Sold Out!', color: 'error' }
			} else if (
				this.event.max_attendees - this.event.attendees.length <=
				Math.ceil(this.event.max_attendees * 0.25)
			) {
				// return { message: 'Almost Full!', color: 'warning' }
				return {
					message:
						String(this.event.max_attendees - this.event.attendees.length) +
						' seats left!',
					color: 'warning'
				}
			} else {
				return { message: null, color: 'white' }
			}
		},
		eventDateStart() {
			let datetime = this.event.date + ' ' + this.event.time_start
			return parse(datetime)//, 'yyyy-MM-dd HH:mm:ss', new Date(2018, 12, 0, 0, 0, 0))
		},
		weekday() {
			return format(this.eventDateStart, 'dddd')
		},
		eventDate() {
			return format(this.eventDateStart, 'MMM Do')
		},
		formattedTime() {
			let start = this.timeToAMPM(this.event.time_start)
			let end = this.timeToAMPM(this.event.time_end)

			if (!start || !end) {
				return ''
			}

			let startSuffix = ''
			let endSuffix = ''

			if (start.includes('a')) {
				startSuffix = 'a'
			} else {
				startSuffix = 'p'
			}

			if (end.includes('a')) {
				endSuffix = 'a'
			} else {
				endSuffix = 'p'
			}

			return (
				start.split(':')[0] +
				startSuffix +
				' - ' +
				end.split(':')[0] +
				endSuffix
			)
		},
		locationShort() {
			return location => {
				let locationString = ''
				if (location.hasOwnProperty('address')) {
					let addressComponents = []
					if (location.address.hasOwnProperty('neighborhood')) {
						if (location.address.neighborhood !== '') {
							addressComponents.push(location.address.neighborhood)
						}
					}
					if (location.address.hasOwnProperty('city')) {
						addressComponents.push(location.address.city)
					}
					locationString = addressComponents.join(', ')
					// for (var i = 0; i < addressComponents.length; i++) {
					// 	locationString += addressComponents[i]
					// 	if (i < addressComponents.length - 1) {
					// 		locationString += ', '
					// 	}
					// }
				}
				return locationString
			}
		},
		locationDistance() {
			let locationLat = this.event.location.public_latitude
			let locationLon = this.event.location.public_longitude
			let userLat = this.getVisitorLocation.lat
			let userLon = this.getVisitorLocation.lon
			let latDifference = Math.abs(locationLat - userLat)
			let lonDifference = Math.abs(locationLon - userLon)
			let latitudeLength = 69.172
			let longitudeLength =
				Math.cos(locationLat * Math.PI / 180.0) * latitudeLength
			let latMiles = latDifference * latitudeLength
			let lonMiles = lonDifference * longitudeLength
			let distance = Math.round(
				Math.sqrt(Math.pow(latMiles, 2) + Math.pow(lonMiles, 2))
			)
			let distanceString = ''

			if (distance < 1) {
				distanceString = '< 1 mile away'
			} else {
				distanceString = distance + ' miles away'
			}

			// distanceString += this.user.default_location_string.split(',')[0]

			return distanceString
		},
		mapSizeOuter() {
			switch (this.$vuetify.breakpoint.name) {
				case 'xs':
					return '90px'
				case 'sm':
					return '90px'
				case 'md':
					return '90px'
				case 'lg':
					return '100px'
				case 'xl':
					return '110px'
			}
		},
		mapSizeInner() {
			switch (this.$vuetify.breakpoint.name) {
				case 'xs':
					return '80px'
				case 'sm':
					return '80px'
				case 'md':
					return '80px'
				case 'lg':
					return '90px'
				case 'xl':
					return '100px'
			}
		},
		freePass() {
			if (this.event) {
				if (this.user.free_pass) {
					if (this.event.location.free_pass_allowed) {
						return true
					}
				}
			}
			return false
		}
	}
}
</script>

<style lang="scss" scoped>

.event-list-item-a {
	display: block;
	width: 100%!important;
	height: 100%!important;
	.event-list-item-card {
		width: 100%!important;
		height: 100%!important;
		.event-list-item-img {
			width: 100%!important;
			height: 100%!important;
		}
	}
}

.event-list-card__top-alert-bar {
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	height: 20px;
	position: absolute;
	top: 0;
	left: 0;
	z-index: 25;
	width: 100%;
	font-size: 0.8em;
}

.event-list-card__button-top-margin {
	height: 20px;
}

.event-list-card {
	cursor: pointer;
	position: relative;
	width: 100%;
	height: 350px;
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
}

.details-flex {
	display: flex;
	align-items: center;
}

.event-list-card__gradient {
	position: absolute;
	top: 0px;
	left: 0px;
	opacity: 0.99;
	z-index: 1;
	pointer-events: none;
	width: 100%;
	/*height: 150px;*/
	height: 100%;
	background: linear-gradient(
		to bottom,
		rgba(0, 0, 0, 0.2) 0%,
		rgba(0, 0, 0, 0) 15%,
		rgba(0, 0, 0, 0) 60%,
		rgba(0, 0, 0, 0.25) 75%,
		rgba(0, 0, 0, 0.75) 100%
	);
}

.event-list-card__click {
	pointer-events: auto;
	cursor: pointer;
	z-index: 3;
	position: absolute;
	width: 100%;
	height: 75%;
	top: 25%;
	// border: 1px solid red;
}

.event-list-card__text {
	width: 100%;
	pointer-events: auto;
	position: absolute;
	bottom: 10px;
	left: 15px;
	line-height: 1.3em;

	> p {
		margin-bottom: 0;
		margin-top: 0;
	}

	.event-list-card__category {
		font-weight: bold;
		letter-spacing: 2px;
		text-transform: uppercase;
		font-size: 0.9em;
		font-family: 'Quantico';
		color: #efefef;
	}
	.event-list-card__location-name {
		font-weight: bold;
		font-size: 1.3em;
		font-family: 'Quantico';
		color: #efefef;
	}
	.event-list-card__location-address {
		font-size: 0.9em;
		color: #bababa !important;
		line-height: 1.15em;
	}
}

.event-list-card__price {
	font-family: 'Quantico';
	position: absolute;
	left: 10px;
	top: 0;
	padding: 20px 15px;
	background: rgba(0, 0, 0, 0.5);
	font-weight: bold;
	font-size: 1.3em;
	color: white;
	pointer-events: auto;
}

.event-list-card__date-circle {
	z-index: 1;
	margin-bottom: -50px;
	margin-right: 28px;
	.event-list-card__date-circle-text {
		line-height: 1.4em;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
}

.event-list-card__buttons {
	z-index: 2;
	pointer-events: auto;
	position: absolute;
	top: 10px;
	right: 15px;
	.event-list-card__button-icon {
		i {
			font-size: 2.5em;
			color: white;
		}
		&:hover {
			i {
				color: #cccccc;
			}
		}
		&:active,
		&:focus {
			outline: 0;
		}
	}
}

.fa:hover {
	cursor: pointer;
}

.card-background-image > div:nth-child(1) {
	opacity: 0.5;
}

.bottom-absolute {
	position: absolute;
	bottom: 0px;
}

.flex-card {
	display: flex;
	flex-grow: 1;
}

.flex-container {
	position: relative;
	width: 100%;
	display: flex;
	flex-flow: row wrap;
}

.item-align-end {
	width: 100%;
	align-self: flex-end;
	display: flex;
	justify-content: flex-end;
}

.date-label {
	font-size: 0.9em;
}
.date-label-2 {
	font-size: 0.8em;
}

.hover-image-scale .card__media__background {
	transition: all 0.3s ease-in-out;
	-webkit-transition: all 0.3s ease-in-out;
}

.hover-image-scale:hover .card__media__background {
	transform: scale(1.02, 1.02);
	transition: all 0.3s ease-in-out;
	-webkit-transform: scale(1.02, 1.02);
	-webkit-transition: all 0.3s ease-in-out;
}

.details-table {
	width: 100%;
	/*border-collapse: collapse;*/
	/*border-spacing: 0;*/
	/*border: 1px solid;*/
	color: #000;
	font-size: 0.9em;
	.details-flex {
		display: flex;
		align-items: center;
	}
	.details-icon {
		/*border: 1px solid;*/
		/*display: inline;*/
		text-align: left;
	}
	.content {
		/*display: inline;*/
		width: 60%;
	}
}

.event-list-item {
	font-size: 1em;
}

.event-list-card__button-margin {
	margin-left: 8px;
}

.event-card-heading-3 {
	color: #bbb;
	font-size: 0.8em;
	line-height: 15px;
}

@media screen and (min-width: 1920px) {
	/*.event-list-item {
		font-size: 1.2em;
	}*/
}

@media screen and (max-width: 1920px) {
	.event-list-card {
		height: 300px;
	}
}

@media screen and (max-width: 1280px) {
	.event-list-card {
		height: 250px;
	}
}

@media screen and (max-width: 960px) {
	.event-list-card {
		height: 300px;
	}
	/*.event-list-card__date-circle {
		margin-bottom: -45px;
		margin-right: 25px;
		.event-list-card__date-circle-text {
			font-size: 0.9em;
		}
	}*/
}

@media screen and (max-width: 599px) {
	.event-list-item {
		padding: 0px 0px 0px 0px;
	}
	.event-card-heading-3 {
		font-size: 0.7em;
		line-height: 14px;
	}
	.event-list-card {
		height: 300px;
	}
	.event-list-card__price {
		left: 12px;
		padding: 16px 12px;
		font-size: 0.9em;
	}
	.event-list-card__date-circle {
		margin-bottom: -38px;
		margin-right: 20px;
		// .event-list-card__date-circle-text {
		// 	font-size: 0.85em;
		// }
	}
	.event-list-card__text {
		left: 10px;
		bottom: 7px;
		font-size: 1em;
	}
	.event-list-card__buttons {
		z-index: 2;
		pointer-events: auto;
		position: absolute;
		top: 10px;
		right: 10px;
		.event-list-card__button-icon {
			i {
				font-size: 2.15em;
			}
		}
	}
	.event-list-card__button-margin {
		margin-left: 5px;
	}
}
</style>
